<template>
    <div>
        <div class="pagetitle">
            <h1>News</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">News</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahNews">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah News
            </a>
        </div>
        <br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Berita</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" class="form-control" id="searchQuery" v-model="searchQuery" @change="getNews" placeholder="Search...">
                            <div class="form-group mb-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select id="pageSize" v-model="pageSize" @change="getNews" class="form-select">
                                    <option v-for="size in sizes" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <table class="table table-striped table-hover">
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col">No</th>
                                    <th scope="col">Judul</th>
                                    <th scope="col">Deskripsi</th>
                                    <th scope="col">Keterangan</th>
                                    <th scope="col">Status</th>
                                    <th scope="col" style="text-align: center;">Opsi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(news, index) in filteredNews" :key="index">
                                    <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                    <td>{{ news.title }}</td>
                                    <td>
                                        <div v-html="news.content"></div>
                                    </td>
                                    <td style="vertical-align: top;">
                                        <div class="d-flex align-items-center">
                                            <a :href="`${apiUrl}${news.news}`" target="_blank">
                                                <img :src="`${apiUrl}${news.news}`" :alt="news.title" class="img-thumbnail me-2" style="max-width: 100px; max-height: 100px; object-fit: cover;">
                                            </a>
                                            <div class="d-flex flex-column">
                                                <span><strong>Created by:</strong> {{ news.created_by_name }}</span>
                                                <span><strong>Created on:</strong> {{ new Date(news.created_on).toLocaleDateString() }}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="news.status == '1'" class="badge bg-success">Active</span>
                                        <span v-else class="badge bg-danger">Inactive</span>
                                    </td>
                                    <td style="text-align:center">
                                        <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', news.id)">
                                            <i class="bi bi-eye fa-sm text-dark"></i>
                                        </a>
                                        <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteNews(news.id, news.news)">
                                            <i class="bi bi-trash fa-sm text-dark"></i>
                                        </a>
                                        <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit', news.id)">
                                            <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul class="pagination justify-content-center" @change="getNews">
                                <li class="page-item" :class="{ disabled: currentPage === 1}">
                                    <button class="page-link" @click ="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                </li>
                                <li v-if="showStartEllipsis" class="page-item disabled">
                                    <span class="page-link">...</span>
                                </li>
                                <li
                                    class="page-item"
                                    v-for="page in displayedPages"
                                    :key="page"
                                    :class="{ active: currentPage === page }"
                                >
                                    <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                </li>
                                <li v-if="showEndEllipsis" class="page-item disabled">
                                    <span class="page-link">...</span>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === pages }">
                                    <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Tambah -->
        <div class="modal fade" id="tambahNews" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Berita Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addNews" enctype="multipart/form-data" :headers="{ 'Content-Type': 'multipart/form-data' }">
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="ID" placeholder="ID" v-model="news.created_by" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="nama" placeholder="nama" v-model="news.created_by_name" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="Title" v-model="news.title">
                                    <label for="floatingName">Title</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating"> 
                                    <!-- <textarea class="form-control" placeholder="Deskripsi" id="floatingTextarea" v-model="news.content" style="height: 150px;"></textarea> -->
                                    <quill-editor
                                        :value="content"
                                        :options="editorOption"
                                        @input="onEditorInput"
                                    ></quill-editor>
                                </div>
                            </div>
                            <div class="col-md-12  mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="news.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="gambar">Gambar</label>
                                    <div class="input-group">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="gambar" @change="handleFileUpload" accept=".png, .jpg, .jpeg">
                                            <label class="custom-file-label" for="gambar">{{ gambarName }}</label>
                                        </div>
                                    </div>
                                    <div v-if="gambarUrl" class="mt-3 text-center">
                                        <img :src="gambarUrl" alt="Selected Image" class="img-thumbnail" style="max-width: 200px; max-height: 200px;">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="news.status">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="button" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form><!-- End floating Labels Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailNewsModal" class="modal fade" id="detailNews" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailNewsModal">Detail News</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="title">Title</label>
                                        <input type="text" class="form-control" id="title" placeholder="Title" v-model="news.title" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="gambar">Gambar</label>
                                        <div class="text-center">
                                            <a :href="`${apiUrl}${news.news}`" target="_blank">
                                                <img :src="`${apiUrl}${news.news}`" alt="client image" width="150" height="150" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <!-- <textarea class="form-control" placeholder="Deskripsi" id="floatingTextarea" v-model="news.content" style="height: 150px;" disabled></textarea> -->
                                        <div class="preview" v-html="news.content"></div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="language">Bahasa</label>
                                        <input type="text" class="form-control" id="language" placeholder="Bahasa" :value="news.language === 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English'" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="pembuat_nama">Nama Pembuat</label>
                                        <input type="text" class="form-control" id="pembuat_nama" placeholder="Nama Pembuat" v-model="news.created_by_name" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" name="status" id="status" v-model="news.status" disabled>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editNews" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editNewsModalLabel">Edit News</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateNews">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by" placeholder="ID" v-model="selectedNews.updated_by" readonly/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by_name" placeholder="Nama PEmbuat" v-model="selectedNews.updated_by_name" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="floatingName" placeholder="ID" v-model="news.id" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="gambar">Gambar</label>
                                    <div class="text-center">
                                        <a :href="`${apiUrl}${news.news}`" target="_blank">
                                            <img :src="`${apiUrl}${news.news}`" alt="client image" width="150" height="150" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12  mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="news.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingInput" placeholder="Title" v-model="news.title" />
                                    <label for="floatingInput">Title</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <!-- <textarea class="form-control" placeholder="Deskripsi" id="floatingTextarea" v-model="news.content" style="height: 150px;"></textarea> -->
                                    <quill-editor
                                        :value="contentEdit"
                                        :options="editorOption"
                                        @input="EditorInputChange"
                                    ></quill-editor>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                <select class="form-select" name="status" id="status" v-model="news.status">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</template>
<script>
import newsjs from './jsNews/news';
export default newsjs;
</script>